/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".uploadPanelCbx{display:block;margin-bottom:10px}.user-panel-link{padding-top:5px}.user-panel-links{display:inline-block;padding-top:10px}.example-form{min-width:150px;max-width:500px;width:100%}.example-full-width{width:30%}.user-panel-password{margin-left:15px}.user-panel-intro{padding-bottom:10px}.user-panel-button{padding-top:10px}.user-panel-warning{font-style:italic;padding-bottom:10px}"];
export { styles as styles };
